<template>
  <div class="font-sans antialiased text-white bg-gray-700">

    <Navbar v-bind:class="{'bg-gray-700': !heroVisibility, 'bg-transparent': heroVisibility}" />
    <Hero :thanks=thanks :dislike=dislike v-observe-visibility="visibilityChanged" />
    <div class="py-16">
      <Collier id="collier"/>
      <Application id="application" />
      <Storytelling2 id="storytelling"/>
      <Storytelling3 />
      <Storytelling />
      <Storytelling4 />
      <IlsParlentDeNous id="ilsparlentdenous"/>
      <Soutenir id="soutenir"/>
      <!-- <Timeline /> -->
    </div>
    <Footer :thanks=thanks :dislike=dislike />
  </div>
</template>

<script>
  // COMPONENTS
  import Hero from './components/Hero.vue'
  import Navbar from './components/Navbar.vue'
  import Application from './components/Application.vue'
  import Collier from './components/Collier.vue'
  import Timeline from './components/Timeline.vue'
  import Footer from './components/Footer.vue'
  import Storytelling from './components/Storytelling.vue'
  import Storytelling2 from './components/Storytelling2.vue'
  import Storytelling3 from './components/Storytelling3.vue'
  import Storytelling4 from './components/Storytelling4.vue'
  import IlsParlentDeNous from './components/IlsParlentDeNous.vue'
  import Soutenir from './components/Soutenir.vue'

  function getURLParameter(name) {
    return (
      decodeURIComponent(
        (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
          location.search
        ) || [null, ""])[1].replace(/\+/g, "%20")
      ) || null
    );
  }

  export default {
    name: 'app',
    props: {
      'thanks': {
        default: false,
        type: Boolean
      },
      'dislike': {
        default: false,
        type: Boolean
      }
    },
    components: {
      Hero,
      Navbar,
      Application,
      Collier,
      Timeline,
      Footer,
      Storytelling,
      Storytelling2,
      Storytelling3,
      Storytelling4,
      IlsParlentDeNous,
      Soutenir
    },
    data: function () {
      return {
        heroVisibility: true
      }
    },
    methods: {
      visibilityChanged(isVisible, entry) {
        if (this.isVisible = isVisible) {
          this.heroVisibility = true
        } else {
          this.heroVisibility = !this.heroVisibility
        }
      },
    },
    mounted() {
    },
    metaInfo: {
      title: 'HerdingCats',
      meta: [{
          name: 'viewport',
          content: 'width=device-width, initial-scale=1'
        },
        {
          name: 'description',
          content: 'Créé par des chercheurs, des ingénieurs et des designers, HerdingCats permet de détecter ses activités durant sa journée. Oui ! Vous saurez enfin ce qu’ils font ! Toilettes, bagarres, votre chat est-il un gros feignant ? Vous saurez tout !'
        },

        // OpenGraph data (Most widely used)
        {
          property: 'og:title',
          content: 'HerdingCats'
        },
        {
          property: 'og:site_name',
          content: 'HerdingCats'
        },
        // The list of types is available here: http://ogp.me/#types
        {
          property: 'og:type',
          content: 'website'
        },
        // Should the the same as your canonical link, see below.
        {
          property: 'og:url',
          content: 'https://herdingcats.fr'
        },
        {
          property: 'og:image',
          content: 'https://herdingcats.fr/opengraph.jpg'
        },
        // Often the same as your meta description, but not always.
        {
          property: 'og:description',
          content: 'Créé par des chercheurs, des ingénieurs et des designers, HerdingCats permet de détecter ses activités durant sa journée. Oui ! Vous saurez enfin ce qu’ils font ! Toilettes, bagarres, votre chat est-il un gros feignant ? Vous saurez tout !'
        },

        // Twitter card
        {
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          name: 'twitter:site',
          content: 'https://herdingcats.fr'
        },
        {
          name: 'twitter:title',
          content: 'HerdingCats'
        },
        {
          name: 'twitter:description',
          content: 'Créé par des chercheurs, des ingénieurs et des designers, HerdingCats permet de détecter ses activités durant sa journée. Oui ! Vous saurez enfin ce qu’ils font ! Toilettes, bagarres, votre chat est-il un gros feignant ? Vous saurez tout !'
        },
        {
          name: 'twitter:image:src',
          content: 'https://herdingcats.fr/twittercard.jpg'
        },

        // Google / Schema.org markup:
        {
          itemprop: 'name',
          content: 'HerdingCats'
        },
        {
          itemprop: 'description',
          content: 'Créé par des chercheurs, des ingénieurs et des designers, HerdingCats permet de détecter ses activités durant sa journée. Oui ! Vous saurez enfin ce qu’ils font ! Toilettes, bagarres, votre chat est-il un gros feignant ? Vous saurez tout !'
        },
        {
          itemprop: 'image',
          content: 'https://herdingcats.fr/opengraph.jpg'
        }
      ]
    }
  };
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,600|Raleway:400,500,700&display=swap');

  * {
    transition: box-shadow 250ms;
    transition: background-color 250ms;
  }
</style>